import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cb0c1164"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-m-auto" }, "Market", -1))
const _hoisted_2 = { class: "p-d-flex p-flex-column p-p-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "title-cat" }, "Search", -1))
const _hoisted_4 = { class: "p-input-icon-left w-100 p-mt-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_6 = { class: "p-flex-column p-ml-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "market-title" }, "Markets", -1))
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "p-d-flex p-justify-between" }
const _hoisted_10 = { class: "tiers" }
const _hoisted_11 = { class: "tier-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_countries_modal = _resolveComponent("countries-modal")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Dialog, {
      visible: _ctx.displayMarketModal,
      class: "p-col-12 p-md-6 p-xl-4 gi-dialog",
      modal: true,
      style: { width: '800px', height : '835px', 'min-height': 'auto' },
      "onUpdate:visible": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:displayMarketModal', false)))
    }, {
      header: _withCtx(() => [
        _hoisted_1
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", {
          style: {"margin-top":"80px","height":"36px"},
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('marketModal', _ctx.activeIndex))),
          class: "continue-button"
        }, " Select Category ")
      ]),
      default: _withCtx(() => [
        _createElementVNode("section", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("span", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.searchValueMarket,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchValueMarket) = $event)),
              placeholder: "Search for Category or Country",
              class: "tittle-input w-50",
              onInput: _ctx.filterMarkets
            }, null, 8, ["modelValue", "onInput"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tiers, (tier, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: `${index}_tier`,
                class: _normalizeClass(["borders", [_ctx.active === index ? 'boarding' : '']]),
                onClick: ($event: any) => (_ctx.active = index)
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.names[index]), 1),
                  (_ctx.active === index)
                    ? (_openBlock(), _createElementBlock("p", {
                        key: 0,
                        class: "see-all p-mt-2",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCountriesModal = true))
                      }, " See all countries "))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.active === index)
                  ? (_openBlock(), _createBlock(_component_countries_modal, {
                      key: 0,
                      onSelectTier: _ctx.selectTier,
                      tier: _ctx.names[index],
                      items: tier,
                      "display-countries-modal": _ctx.showCountriesModal,
                      "onUpdate:displayCountriesModal": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showCountriesModal) = $event))
                    }, null, 8, ["onSelectTier", "tier", "items", "display-countries-modal"]))
                  : _createCommentVNode("", true),
                _createElementVNode("p", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tier, (t, idx) => {
                    return (_openBlock(), _createElementBlock("span", {
                      key: idx + 't'
                    }, _toDisplayString(t) + _toDisplayString(tier[idx + 1] ? ', ' : ''), 1))
                  }), 128))
                ])
              ], 10, _hoisted_8))
            }), 128))
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}